module.exports = __webpack_public_path__ + "img/plus.0fac7549.svg";